export const DEFAULT_FILTER_DATE_FORMAT = "dd.MM.yyyy";
export const DEFAULT_FILTER_TIME_FORMAT = "HH:mm";

/** Gap in px between the filter cell and the dropdown it opens. */
export const FILTER_DROPDOWN_OFFSET_PX = 4;

/** Pause in editing after which a filter edit applies itself; each one reloads the rows. */
export const FILTER_APPLY_DEBOUNCE_MS = 400;
